// extracted by mini-css-extract-plugin
module.exports = {"priceFilter":"styles_priceFilter__3fNBH","priceInput":"styles_priceInput__NfD7h"};